export default {
  "radarProjectId": "4fedaf2ec1",
  "sampleRate": 1
}